import { t } from "@/lib/i18n";

// Notification-related constants
export const NOTIF_TOAST_DISMISSED_AT_KEY = "notif_toast_dismissed_at";
export const NOTIF_TOAST_DISMISS_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours
export const NOTIF_BLOCKED_TOAST_DISMISSED_AT_KEY =
  "notif_blocked_toast_dismissed_at";

// Tournament fee structure constants
export const TOURNAMENT_FEE_PERCENTAGE = 0.15; // 15% total fee
export const USER_FEE_PERCENTAGE = 0.3; // 30% of fee goes back to users
export const REFERRAL_SPLIT_PERCENTAGE = 0.8; // 80% of user fee for referral
export const CASHBACK_SPLIT_PERCENTAGE = 0.2; // 20% of user fee for cashback
export const GEOMETRIC_RATIO = 0.6; // Ratio for geometric weight distribution
export const GAS_FEE_PERCENTAGE = 0.005; // 0.5% gas fee deducted from winners pool
export const RUSH_FEE_PERCENTAGE = {
  rush: 0.15,
  grand: 0.15,
};

// Excess payout return flow
// localStorage key prefix to mark an address has returned excess payout
export const LS_EXCESS_PAYOUT_RETURNED_PREFIX = "excessPayoutReturned:";
// Default amount in USD to return for the excess payout
export const EXCESS_PAYOUT_AMOUNT_SOL = 1.278;
// Recipient address for excess payout returns
export const EXCESS_PAYOUT_RECIPIENT =
  "F3z9fk19JBEYGxex3MoKE7Xx1pcoykJRC8FrrGqAHsH4";

// Per-wallet excess payout amount mapping
export const EXCESS_PAYOUT_TARGETS: { wallet: string; amount: number }[] = [
  // { wallet: "BxftW8VqSqJG8jJikXAW7itGJD158WyZ4vtw7Mx5cqN5", amount: 0.001 },
  { wallet: "95779Rw1DBSDPvkM8vCdJwJqgf98tDNDMojxQJ6HhJsc", amount: 0.001 },
  // { wallet: "EXigSsRGDxjboESy2WSFPYohkq3DnGoRnVpxpgFscX1y", amount: 0.001 },

  // { wallet: "2AGbDbfMQNcC7DjVh5oRjCVQp58PHW7DhnboUheWsJGf", amount: 1.278 }, // 117798.skr
  // { wallet: "2ye4ex7pFSc348KqGgCAd5m8yUASLufL1SMzmUas8UXk", amount: 0.654 }, // miyax.skr
  { wallet: "3dd5jBBAymVpYoZvUbmDcfHSBzSSzKsPQKMqPGoR8YSY", amount: 1.377 }, // biri4aaa.skr
  // { wallet: "7bwzXpZWuXPJwifkgdchzEPBNEzzcrWB5dtw6X9ETLvu", amount: 0.483 },
  { wallet: "9sLR53nTfBa3RbPW1Boa25Pdumtq3oTgxcpeA7UCERyf", amount: 0.312 }, // brukaliff.skr
  // { wallet: "A2NcDJ8RpGAb4sLLJHEAY9ootf75pFjUvkKopAg72bgZ", amount: 0.6105 }, // flipstar.skr
  // { wallet: "BaZS7LWm5nWPqrahcPDGED9DufnZceDcGEuuv3YSwESt", amount: 0.171 }, // ericelisha.sol
  { wallet: "CbKmbvihbWeuGnT5U9wUexv9kLzRkFo9fLab5f1YBzXt", amount: 0.156 },
  { wallet: "DyPdQHwUj1b1KfacmuHJ3bfE5XUeUJQBM9pXnVsYHvVD", amount: 0.156 }, // unaind.skr
  { wallet: "EJDrxiHr2dRawkVKWUuVienqNpgrha9rMeQjMSDUMEvy", amount: 0.156 }, // willow.skr
  { wallet: "EXptjzpkQcux6Hm9dEyJVjGcbJgrWV8gWRggbicaD5Cd", amount: 0.171 }, // mastercheese.skr
  // { wallet: "Kkn2SniwLUPf6ZNSc6UfjtJw5L3kpXiDjbsSAxwZXtU", amount: 0.156 }, // thenftmania.skr
];

export const isRushLeaderboardFlipped = Date.now() / 1000 > 1768809600;
export const RUSH_GRAND_RUSH_REWARD_SWAP_AT = 1770681600; // Feb 10, 2026 00:00:00 UTC

export const getOnboardingLoggedOutDialogSteps = () => [
  {
    id: "intro",
    title: t("onboarding.loggedOut.intro.title"),
    description: t("onboarding.loggedOut.intro.description"),
    imageUrl:
      "https://cdn.navalabs.io/images/quick-tutorial/volatility_o6N8Cw.png",
    imageAlt: t("onboarding.loggedOut.intro.imageAlt"),
  },
  {
    id: "step1",
    title: t("onboarding.loggedOut.step1.title"),
    description: t("onboarding.loggedOut.step1.description"),
    imageUrl: "https://cdn.navalabs.io/images/quick-tutorial/draft_74DvR6.png",
    imageAlt: t("onboarding.loggedOut.step1.imageAlt"),
  },
  {
    id: "step2",
    title: t("onboarding.loggedOut.step2.title"),
    description: t("onboarding.loggedOut.step2.description"),
    imageUrl: "https://cdn.navalabs.io/images/quick-tutorial/pnl_yN5jC6.png",
    imageAlt: t("onboarding.loggedOut.step2.imageAlt"),
  },
  {
    id: "step3",
    title: t("onboarding.loggedOut.step3.title"),
    description: t("onboarding.loggedOut.step3.description"),
    imageUrl: "https://cdn.navalabs.io/images/quick-tutorial/earn_1qtEma.png",
    imageAlt: t("onboarding.loggedOut.step3.imageAlt"),
  },
];

export const getOnboardingLoggedInDialogSteps = () => [
  {
    id: "welcome",
    title: t("onboarding.loggedIn.welcome.title"),
    description: t("onboarding.loggedIn.welcome.description"),
    imageUrl:
      "https://cdn.navalabs.io/images/quick-tutorial/win-prizes_Z6An3J.png",
    imageAlt: t("onboarding.loggedIn.welcome.imageAlt"),
  },
  {
    id: "complete",
    title: t("onboarding.loggedIn.complete.title"),
    description: t("onboarding.loggedIn.complete.description"),
    imageUrl:
      "https://cdn.navalabs.io/images/quick-tutorial/leaderboard_HeFDh8.png",
    imageAlt: t("onboarding.loggedIn.complete.imageAlt"),
  },
  {
    id: "compete",
    title: t("onboarding.loggedIn.compete.title"),
    description: t("onboarding.loggedIn.compete.description"),
    imageUrl:
      "https://cdn.navalabs.io/images/quick-tutorial/championship_XjNsv2.png",
    imageAlt: t("onboarding.loggedIn.compete.imageAlt"),
  },
];
